<!-- Seletor de método de pagamento -->
<!--<div class="payment-methods">
  <button
    type="button"
    class="payment-method"
    [class.payment-method&#45;&#45;active]="paymentMethod === 'pix'"
    (click)="selectMethod('pix')"
  >
    <i class="fa-brands fa-pix"></i>
    <span>PIX</span>
  </button>

&lt;!&ndash;  Fatura (bolepix) — PDF com o mesmo QR do PIX&ndash;&gt;
  <button
    type="button"
    class="payment-method"
    [class.payment-method&#45;&#45;active]="paymentMethod === 'boleto'"
    (click)="selectMethod('boleto')"
  >
    <i class="fa-solid fa-file-invoice"></i>
    <span>Fatura</span>
  </button>

&lt;!&ndash;  Cartão — gateway não definido ainda; desabilitado&ndash;&gt;
  <button
    type="button"
    class="payment-method"
    [disabled]="true"
    title="Em breve"
  >
    <i class="fa-regular fa-credit-card"></i>
    <span>Cartão</span>
    <span class="rsm-badge-soon">Em breve</span>
  </button>
</div>-->

<!-- PIX: estado inicial — botão Gerar PIX -->
<!--<div class="d-flex flex-column align-items-center p-4" *ngIf="paymentMethod === 'pix' && !generated">
  <button
    type="button"
    mat-raised-button
    class="buttonCheckout btn-blue"
    [disabled]="isGenerating"
    (click)="generate.emit()"
  >
    <ng-container *ngIf="!isGenerating">
      <i class="fa-brands fa-pix me-2"></i> Gerar PIX
    </ng-container>
    <ng-container *ngIf="isGenerating">
      <i class="fa-solid fa-spinner fa-spin me-2"></i> Gerando...
    </ng-container>
  </button>
</div>-->

<!-- PIX: QR code gerado — aguardando ou confirmado -->
<!--<div *ngIf="generated && paymentMethod === 'pix'">
  <ng-container *ngIf="!confirmed">
    <div class="paymentType">
      <div class="boxPaymantType">
        <i class="fa-brands fa-pix"></i>
        <p class="titlePaymentType"><b>Pagar com PIX</b></p>
      </div>
    </div>

    <div class="boxQrCode">
      <div class="containerQrCode">
        <qrcode
          [qrdata]="qrCode || '0000'"
          [width]="140"
          [errorCorrectionLevel]="'H'"
        ></qrcode>
      </div>
      <div class="containerStepPix">
        <div class="stepPix">
          <div class="stepNumber" title="1">1</div>
          <p class="stepDescription">
            Abra o app do seu banco ou instituição financeira e selecione a
            opção Pix.
          </p>
        </div>
        <div class="stepPix">
          <div class="stepNumber" title="2">2</div>
          <p class="stepDescription">
            Escolha a opção pagar com qr code e escaneie o código ao lado.
          </p>
        </div>
        <div class="stepPix">
          <div class="stepNumber" title="3">3</div>
          <p class="stepDescription">
            Confirme as informações e finalize a compra.
          </p>
        </div>
      </div>
    </div>

    &lt;!&ndash; Spinner de verificação — enquanto a confirmação está sendo checada &ndash;&gt;
    <div class="polling-status" *ngIf="checking">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <span>{{ checkingMessage }}</span>
    </div>

    &lt;!&ndash; Mensagem de aguardo — quando a checagem expirou &ndash;&gt;
    <div class="polling-status polling-status&#45;&#45;waiting" *ngIf="timedOut">
      <i class="fa-solid fa-clock"></i>
      <span>{{ timedOutMessage }}</span>
    </div>

    <div class="d-flex flex-column gap-3 p-4">
      <button
        type="button"
        mat-raised-button
        (click)="copy.emit()"
        class="buttonCheckout btn-blue"
      >
        Copiar código Pix
      </button>

      <button
        type="button"
        mat-stroked-button
        (click)="retry.emit()"
        class="buttonCheckout btn-white-outline"
      >
        Gerar novo Pix
      </button>
    </div>
  </ng-container>

  &lt;!&ndash; Confirmado &ndash;&gt;
  <div class="polling-status polling-status&#45;&#45;confirmed" *ngIf="confirmed">
    <i class="fa-solid fa-circle-check"></i>
    <span>{{ confirmedMessage }}</span>
  </div>
</div>-->

<!-- FATURA: "Gerar fatura" antes de gerar → rsm-boleto-view inline após gerar -->
<div *ngIf="paymentMethod === 'boleto'">

  <!-- Estado inicial: fatura ainda não gerada -->
  <div class="d-flex flex-column align-items-center p-4" *ngIf="!generated && !confirmed">
    <button
      type="button"
      mat-raised-button
      class="buttonCheckout btn-blue"
      [disabled]="isGeneratingBoleto"
      (click)="generateBoleto.emit()"
    >
      <ng-container *ngIf="!isGeneratingBoleto">
        <i class="fa-solid fa-file-invoice me-2"></i> Gerar fatura
      </ng-container>
      <ng-container *ngIf="isGeneratingBoleto">
        <i class="fa-solid fa-spinner fa-spin me-2"></i> Gerando...
      </ng-container>
    </button>
    <small class="text-muted mt-2" style="font-size: 0.75rem; text-align: center;">
      A fatura é um PDF com o QR Code do PIX para pagamento bancário.
    </small>
  </div>

  <!-- Após gerar: exibe o boleto inline (idêntico ao checkout de campanha) -->
  <div *ngIf="generated && !confirmed" class="p-3">
    <rsm-boleto-view
      [amount]="amount"
      [dueDate]="dueDate"
      [qrCode]="qrCode"
      [description]="boletoDescription"
      [descriptionDetail]="boletoDescriptionDetail"
      [infoLine]="boletoInfoLine"
      [isDownloading]="isGeneratingBoleto"
      [checking]="checking"
      [timedOut]="timedOut"
      [confirmed]="confirmed"
      [confirmedMessage]="confirmedMessage"
      [checkingMessage]="checkingMessage"
      [timedOutMessage]="timedOutMessage"
      (download)="downloadBoleto.emit()"
      (copy)="copy.emit()"
      (retry)="retry.emit()"
    ></rsm-boleto-view>
  </div>

  <!-- Confirmado -->
  <div class="polling-status polling-status--confirmed" *ngIf="confirmed">
    <i class="fa-solid fa-circle-check"></i>
    <span>{{ confirmedMessage }}</span>
  </div>
</div>
